import React from 'react';
import { Link } from 'react-router';

export default class ButtonRounded extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      linkTo,
      children,
      mailTo,
      href,
      onClick,
      ...restProps
    } = this.props;

    if (linkTo) {
      return (
        <Link {...restProps} to={linkTo} className={this.getCSSClasses()}>
          {children}
        </Link>
      );
    } else if (onClick) {
      return (
        <a
          {...restProps}
          onClick={onClick}
          href="javascript:void(0);"
          className={this.getCSSClasses()}
        >
          {children}
        </a>
      );
    } else if (mailTo) {
      return (
        <a
          {...restProps}
          href={`mailto:${mailTo}`}
          className={this.getCSSClasses()}
        >
          {children}
        </a>
      );
    } else if (href) {
      return (
        <a {...restProps} href={href} className={this.getCSSClasses()}>
          {children}
        </a>
      );
    }

    return (
      <Link {...restProps} to="#" className={this.getCSSClasses()}>
        {children}
      </Link>
    );
  }

  getCSSClasses() {
    let classString = 'button-rounded';
    if ('variant' in this.props && this.props.variant.length != 0) {
      classString += ' ' + this.props.variant;
    }

    return classString;
  }
}



// WEBPACK FOOTER //
// ./client/components/common/button-rounded/button-rounded.es6